import React, { useState } from 'react';
import { ArrowLeft, Loader, Gamepad2 } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTVNavigation } from '../hooks/useTVNavigation';

const Games = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const selectedGame = location.state?.game || null;
  const [isLoading, setIsLoading] = useState(false);

  useTVNavigation({ enabled: true, onBack: () => navigate('/') });

  // ⭐ 15 Puzzle & Logic Games
    const gameList = [
    {
        id: 1,
        name: "Super Mario",
        description: "Play a Many Games",
        image: "/Assets/Photo/super_mario.png",
        url: "https://html5.gamemonetize.co/zk99zkldgfzm89l2g56hhf5rfzitm9x8/"
    },
    {
        id: 3,
        name: "Prety Little Baby",
        description: "Vertical puzzle logic game",
        image: "/Assets/Photo/barbie.png",
        url: "https://html5.gamemonetize.co/zrtqkjxopyl2qv5yfgpy0iuowpscnd7z/"
    },
    {
        id: 5,
        name: "Ultimate Puzzle Pro",
        description: "Puzzle game",
        image: "/Assets/Photo/puzzle.png",
        url: "https://html5.gamemonetize.co/0hvpeh7isix8tk9003wger45add5he5q/"
    }
    ];

  const handleCardClick = (game) => {
    setIsLoading(true);
    navigate("/games/play", { state: { game } });
  };

  const handleBack = () => navigate("/games");

  const isIframePage = location.pathname === "/games/play";

  // ⭐ CARD PAGE
  if (!isIframePage) {
    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-800 to-black  pt-32 px-6">

          <div data-tv-grid className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 gap-6">
            {gameList.map((game) => (
                <div
                key={game.id}
                data-tv-card
                tabIndex={0}
                onClick={() => handleCardClick(game)}
                onKeyDown={e => e.key === 'Enter' && handleCardClick(game)}
                className="bg-transparent rounded-xl overflow-hidden cursor-pointer transition border-2 hover:border-cyan-400 focus:border-cyan-400 focus:outline-none focus:scale-105"
                >
                <img src={game.image} className="h-48 w-full object-cover" />

                <div className="p-4 mb-6">
                  <h3 className="text-lg font-semibold">{game.name}</h3>
                  <p className="text-gray-300 text-sm">{game.description}</p>

                  <div className="flex justify-end -mt-10">
                    <Gamepad2 className="w-5 h-5 text-purple-400" />
                  </div>
                </div>
              </div>
            ))}
          </div>

            <div className="text-center py-8 border-t border-gray-800 mt-96">
                <p className="text-gray-400 text-sm">
                Access quality education resources from trusted sources
                </p>
            </div>
        </div>
      );
  }

  // ⭐ IFRAME PAGE
  return (
    <div className="min-h-screen bg-black">

      <button
        onClick={handleBack}
        className="fixed top-4 left-4 z-50 bg-white/10 text-white px-4 py-2 rounded-full backdrop-blur-md"
      >
        <ArrowLeft className="inline w-5 h-5 mr-2" />
        Back
      </button>

      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-black/80 z-40">
          <Loader className="w-16 h-16 text-purple-500 animate-spin" />
        </div>
      )}

      <iframe
        src={selectedGame?.url}
        onLoad={() => setIsLoading(false)}
        className="w-full h-screen border-0"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default Games;